module.exports = __webpack_public_path__ + "static/img/880cc6b0-993b-4de0-a0a6-200e545e85ff.f884e9b6.png";